import type { MessageType } from "@intelligems/ig-types/schemas/plugin-debug-types";

type TypeArg = {
  type: MessageType;
};

export function message(msg: TypeArg & Record<string, unknown>, origin = "*") {
  window.postMessage(msg, "*");
  if (window.parent) {
    //window.postMessage(msg, origin);
    window.parent.postMessage(msg, origin);
  }
  if (window.opener) {
    //window.postMessage(msg, origin);
    window.opener.postMessage(msg, origin);
  }
}
